import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=378bc0f2&scoped=true&"
import script from "./framework.vue?vue&type=script&lang=js&"
export * from "./framework.vue?vue&type=script&lang=js&"
import style0 from "./framework.vue?vue&type=style&index=0&id=378bc0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bc0f2",
  null
  
)

export default component.exports